// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2YPpM","displayModal":"Modal_displayModal__1Z93L","modal":"Modal_modal__2GaZB","closeBtn":"Modal_closeBtn__3UuM-","title":"Modal_title__35XDc"};